module.exports = __webpack_public_path__ + "static/media/map_icon_charger_available.217623dd.gif";